
const cardKey = Symbol('card');
export const getCardData = ({
	card,
	rect,
	columnId
}) => {
	return {
		[cardKey] : true,
		rect,
		card,
		columnId
	};
};

export const isCardData = (value) =>
{
	return Boolean(value[cardKey]);
}

export const isDraggingACard = ({ source }) =>
{
	return isCardData(source.data);
}

const cardDropTargetKey = Symbol('card-drop-target');
export const getCardDropTargetData = ({
	card,
	columnId,
}) => {
	return {
		[cardDropTargetKey]: true,
		card,
		columnId
	};
};

export const isCardDropTargetData = (value) =>
{
	return Boolean(value[cardDropTargetKey]);
}

const columnKey = Symbol('column');
export const getColumnData = ({ column }) =>
{
	return {
		[columnKey]: true,
		column
	};
}

export const isColumnData = (value) =>
{
	return Boolean(value[columnKey]);
}

export const isDraggingAColumn = ({ source }) =>
{
	return isColumnData(source.data);
}
